import { useMemo } from 'react';
import { updateClip } from '@goldcast/player-config/src/retrievers/updateClip';
import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { getClipVersion } from '@goldcast/player-config/src/utils/clipUtils';
import { updateClipWithId } from '@/stores/clip';
import { showErrorToast } from '@/libs/toast/toast';
import useAnalytics from '@/hooks/useAnalytics';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

export default function useClipShareHook(): {
  setCurrentClipAsShared: () => void;
  clipShareLink: string;
} {
  const { trackContentShare } = useAnalytics();

  const { clipId, clipData } = useClipsContext();

  const clipShareLink = useMemo(() => {
    return `${window.location.origin}/shared/clip/${clipData.id}`;
  }, [clipData.id]);

  function trackOpenPopup(isSuccess: boolean = true) {
    trackContentShare({
      contentType: 'CLIP',
      source: 'EditorPage',
      shareType: 'OpenPopup',
      isSuccess,
      asset: clipData
    });
  }

  function setCurrentClipAsShared() {
    if (clipData.shared) {
      return;
    }

    const finalClip: Clip = { ...clipData, version: getClipVersion() };

    updateClipWithId(clipId, { shared: true });
    updateClip({ ...finalClip, shared: true })
      .then(() => trackOpenPopup())
      .catch(() => {
        trackOpenPopup(false);
        showErrorToast('Something went wrong while sharing the clip. Please try again later.');
      });
  }

  return {
    setCurrentClipAsShared,
    clipShareLink
  };
}
